import { IStringConstraintPattern } from '../../model/base/annotation';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ValidationConstants } from '../validation-constants';
import { format } from './string.util';

export function getGeneralNamePatterns(resourceType: string): IStringConstraintPattern[] {
    return [
        {
            message: format(shellStringResources.Validator_NamePattern_StartEnd_AlphanumericUnderscore, resourceType),
            regex: ValidationConstants.startEndWithAlphaNumericUnderscoreValidator
        },
        {
            message: format(shellStringResources.Validator_NameMaxLength, resourceType, ValidationConstants.maxEntityNameLength.toString()),
            regex: ValidationConstants.factoryEntityNameLengthValidator
        },
        {
            message: format(shellStringResources.Validator_NamePattern_All_AlphanumericUnderscoreDashSpace, resourceType),
            regex: ValidationConstants.allSupportedCharValidator
        }
    ];
}

export function validateName(name: string, resourceType: string): string[] {
    if (!name) {
        return [format(shellStringResources.Validator_NameRequired, resourceType)];
    }
    return [...getGeneralNamePatterns(resourceType)].map(
        (validator) => validator.regex.test(name) ? '' : validator.message
    ).filter((msg) => msg);
}
